// Logout User
export const LOGIN_USER = "LOGIN_USER";
export const LOGIN_USER_SUCCESS = "LOGIN_USER_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";

// Logout User
export const LOGOUT_USER = "LOGOUT_USER";
export const LOGOUT_USER_SUCCESS = "LOGOUT_USER_SUCCESS";
export const LOGOUT_FAILURE = "LOGOUT_FAILURE";

// Add Email
export const ADD_EMAIL = "ADD_EMAIL";
export const ADD_EMAIL_SUCCESS = "ADD_EMAIL_SUCCESS";
export const EMAIL_FAILURE = "EMAIL_FAILURE";